/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_CoatInputs */

const en_val_coat = /** @type {(inputs: Val_CoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coat`)
};

const es_val_coat = /** @type {(inputs: Val_CoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrigo`)
};

const fr_val_coat = /** @type {(inputs: Val_CoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manteau`)
};

const de_val_coat = /** @type {(inputs: Val_CoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantel`)
};

const ja_val_coat = /** @type {(inputs: Val_CoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コート`)
};

const zh_val_coat = /** @type {(inputs: Val_CoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大衣`)
};

const ar_val_coat = /** @type {(inputs: Val_CoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معطف`)
};

const id_val_coat = /** @type {(inputs: Val_CoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantel`)
};

const it_val_coat = /** @type {(inputs: Val_CoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cappotto`)
};

const ru_val_coat = /** @type {(inputs: Val_CoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пальто`)
};

const pt_val_coat = /** @type {(inputs: Val_CoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casaco`)
};

const ko_val_coat = /** @type {(inputs: Val_CoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코트`)
};

/**
* | output |
* | --- |
* | "Coat" |
*
* @param {Val_CoatInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_coat = /** @type {((inputs?: Val_CoatInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_CoatInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_coat(inputs)
	if (locale === "es") return es_val_coat(inputs)
	if (locale === "fr") return fr_val_coat(inputs)
	if (locale === "de") return de_val_coat(inputs)
	if (locale === "ja") return ja_val_coat(inputs)
	if (locale === "zh") return zh_val_coat(inputs)
	if (locale === "ar") return ar_val_coat(inputs)
	if (locale === "id") return id_val_coat(inputs)
	if (locale === "it") return it_val_coat(inputs)
	if (locale === "ru") return ru_val_coat(inputs)
	if (locale === "pt") return pt_val_coat(inputs)
	return ko_val_coat(inputs)
});